import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-[900px] mx-auto bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-3xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">{appInfo.title}</h2>
            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6">{appInfo.desc}</p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-6">
              {appInfo.features.map((f, i) => (
                <span key={i} className="inline-block px-3 py-1.5 text-xs font-medium bg-white/15 text-white rounded-full whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white text-primary-600 font-medium text-sm rounded-full hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-line text-lg"></i>
                App Store
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/15 text-white font-medium text-sm rounded-full hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <img
              src={appInfo.qrImg}
              alt="天堂影视 APP 下载二维码"
              className="w-36 h-36 md:w-44 md:h-44 rounded-2xl bg-white p-3"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}